// extracted by mini-css-extract-plugin
export default {"body":"DIdjSOJhHzz_X1l1PjmS","image":"NEKPOA3VRxbrPddJyiJf","text":"AKrmEpuZW6LPBqlVzXEp","close":"RqJazT_GklLbNbO2KPin"};